import { createColumnHelper } from '@tanstack/react-table';
import type { File, SoftwareKey } from '../../../../types/file.types';
import { SoftwareCell } from '../../../FileCells/SoftwareCell';

const columnHelper = createColumnHelper<File>();

export const SoftwareColumn = columnHelper.accessor('logiciel', {
  id: 'logiciel',
  header: 'Logiciel',
  cell: (info) => <SoftwareCell softwareKey={info.getValue() as SoftwareKey} />,
  size: 80,
});
